import { SiteCountry } from '../data/models/locale'

export function getCountryFromUrl(url: string): SiteCountry {
  const cc = url.substr(1, 2) as SiteCountry
  const validCode = Object.values(SiteCountry).indexOf(cc) !== -1

  return validCode ? cc : SiteCountry.nl
}
